// Auto-generated file - DO NOT EDIT
// This file is generated by scripts/generate-custom-element-tags.mjs

/**
 * Set of all custom element tags defined in the Atomic library.
 * This is generated at build time from @customElement decorators (Lit components only).
 * Stencil components are excluded as they lazy-load.
 */
export const ATOMIC_CUSTOM_ELEMENT_TAGS = new Set<string>([
  'atomic-aria-live',
  'atomic-ask-follow-up-input',
  'atomic-automatic-facet',
  'atomic-automatic-facet-generator',
  'atomic-breadbox',
  'atomic-category-facet',
  'atomic-citation',
  'atomic-color-facet',
  'atomic-commerce-breadbox',
  'atomic-commerce-category-facet',
  'atomic-commerce-did-you-mean',
  'atomic-commerce-facet',
  'atomic-commerce-facet-number-input',
  'atomic-commerce-facets',
  'atomic-commerce-interface',
  'atomic-commerce-layout',
  'atomic-commerce-load-more-products',
  'atomic-commerce-no-products',
  'atomic-commerce-numeric-facet',
  'atomic-commerce-pager',
  'atomic-commerce-product-list',
  'atomic-commerce-products-per-page',
  'atomic-commerce-query-error',
  'atomic-commerce-query-summary',
  'atomic-commerce-recommendation-interface',
  'atomic-commerce-recommendation-list',
  'atomic-commerce-refine-modal',
  'atomic-commerce-refine-toggle',
  'atomic-commerce-search-box',
  'atomic-commerce-search-box-instant-products',
  'atomic-commerce-search-box-query-suggestions',
  'atomic-commerce-search-box-recent-queries',
  'atomic-commerce-sort-dropdown',
  'atomic-commerce-text',
  'atomic-commerce-timeframe-facet',
  'atomic-component-error',
  'atomic-did-you-mean',
  'atomic-external',
  'atomic-facet',
  'atomic-facet-date-input',
  'atomic-facet-manager',
  'atomic-facet-number-input',
  'atomic-facet-placeholder',
  'atomic-field-condition',
  'atomic-focus-trap',
  'atomic-folded-result-list',
  'atomic-format-currency',
  'atomic-format-number',
  'atomic-format-unit',
  'atomic-generated-answer',
  'atomic-generated-answer-content',
  'atomic-generated-answer-feedback-modal',
  'atomic-generated-answer-inline-link',
  'atomic-generated-answer-thread',
  'atomic-generated-answer-thread-item',
  'atomic-html',
  'atomic-icon',
  'atomic-insight-edit-toggle',
  'atomic-insight-facet',
  'atomic-insight-folded-result-list',
  'atomic-insight-full-search-button',
  'atomic-insight-generate-answer-button',
  'atomic-insight-generated-answer',
  'atomic-insight-history-toggle',
  'atomic-insight-interface',
  'atomic-insight-layout',
  'atomic-insight-no-results',
  'atomic-insight-numeric-facet',
  'atomic-insight-pager',
  'atomic-insight-query-error',
  'atomic-insight-query-summary',
  'atomic-insight-refine-modal',
  'atomic-insight-refine-toggle',
  'atomic-insight-result',
  'atomic-insight-result-action',
  'atomic-insight-result-action-bar',
  'atomic-insight-result-attach-to-case-action',
  'atomic-insight-result-attach-to-case-indicator',
  'atomic-insight-result-children',
  'atomic-insight-result-children-template',
  'atomic-insight-result-list',
  'atomic-insight-result-quickview-action',
  'atomic-insight-result-template',
  'atomic-insight-search-box',
  'atomic-insight-smart-snippet',
  'atomic-insight-smart-snippet-feedback-modal',
  'atomic-insight-smart-snippet-suggestions',
  'atomic-insight-tab',
  'atomic-insight-tabs',
  'atomic-insight-timeframe-facet',
  'atomic-insight-user-actions-modal',
  'atomic-insight-user-actions-session',
  'atomic-insight-user-actions-timeline',
  'atomic-insight-user-actions-toggle',
  'atomic-ipx-button',
  'atomic-ipx-embedded',
  'atomic-ipx-modal',
  'atomic-ipx-recs-list',
  'atomic-ipx-refine-modal',
  'atomic-ipx-refine-toggle',
  'atomic-ipx-result-link',
  'atomic-ipx-tab',
  'atomic-ipx-tabs',
  'atomic-layout-section',
  'atomic-load-more-results',
  'atomic-modal',
  'atomic-no-results',
  'atomic-notifications',
  'atomic-numeric-facet',
  'atomic-numeric-range',
  'atomic-pager',
  'atomic-popover',
  'atomic-product',
  'atomic-product-children',
  'atomic-product-description',
  'atomic-product-excerpt',
  'atomic-product-field-condition',
  'atomic-product-image',
  'atomic-product-link',
  'atomic-product-multi-value-text',
  'atomic-product-numeric-field-value',
  'atomic-product-price',
  'atomic-product-rating',
  'atomic-product-section-actions',
  'atomic-product-section-badges',
  'atomic-product-section-bottom-metadata',
  'atomic-product-section-children',
  'atomic-product-section-description',
  'atomic-product-section-emphasized',
  'atomic-product-section-metadata',
  'atomic-product-section-name',
  'atomic-product-section-visual',
  'atomic-product-template',
  'atomic-product-text',
  'atomic-query-error',
  'atomic-query-summary',
  'atomic-quickview',
  'atomic-quickview-modal',
  'atomic-rating-facet',
  'atomic-rating-range-facet',
  'atomic-recs-error',
  'atomic-recs-interface',
  'atomic-recs-list',
  'atomic-recs-result',
  'atomic-recs-result-template',
  'atomic-refine-modal',
  'atomic-refine-toggle',
  'atomic-relevance-inspector',
  'atomic-result',
  'atomic-result-badge',
  'atomic-result-children',
  'atomic-result-children-template',
  'atomic-result-date',
  'atomic-result-fields-list',
  'atomic-result-html',
  'atomic-result-icon',
  'atomic-result-image',
  'atomic-result-link',
  'atomic-result-list',
  'atomic-result-localized-text',
  'atomic-result-multi-value-text',
  'atomic-result-number',
  'atomic-result-placeholder',
  'atomic-result-printable-uri',
  'atomic-result-rating',
  'atomic-result-section-actions',
  'atomic-result-section-badges',
  'atomic-result-section-bottom-metadata',
  'atomic-result-section-children',
  'atomic-result-section-emphasized',
  'atomic-result-section-excerpt',
  'atomic-result-section-title',
  'atomic-result-section-title-metadata',
  'atomic-result-section-visual',
  'atomic-result-table-placeholder',
  'atomic-result-template',
  'atomic-result-text',
  'atomic-result-timespan',
  'atomic-results-per-page',
  'atomic-search-box',
  'atomic-search-box-instant-results',
  'atomic-search-box-query-suggestions',
  'atomic-search-box-recent-queries',
  'atomic-search-interface',
  'atomic-search-layout',
  'atomic-segmented-facet',
  'atomic-segmented-facet-scrollable',
  'atomic-smart-snippet',
  'atomic-smart-snippet-answer',
  'atomic-smart-snippet-collapse-wrapper',
  'atomic-smart-snippet-expandable-answer',
  'atomic-smart-snippet-feedback-modal',
  'atomic-smart-snippet-source',
  'atomic-smart-snippet-suggestions',
  'atomic-sort-dropdown',
  'atomic-sort-expression',
  'atomic-tab',
  'atomic-tab-bar',
  'atomic-tab-button',
  'atomic-tab-manager',
  'atomic-tab-popover',
  'atomic-table-element',
  'atomic-text',
  'atomic-timeframe',
  'atomic-timeframe-facet',
]);